var map = {
	"./auth/auth": 520,
	"./auth/auth-corporate": 521,
	"./auth/auth-corporate.jpg": 521,
	"./auth/auth.jpg": 520,
	"./auth/bexwebapp_bg": 522,
	"./auth/bexwebapp_bg.png": 522,
	"./auth/brain": 523,
	"./auth/brain-hero": 524,
	"./auth/brain-hero.svg": 524,
	"./auth/brain.png": 523,
	"./auth/campus-cap": 525,
	"./auth/campus-cap-login": 526,
	"./auth/campus-cap-login.jpg": 526,
	"./auth/campus-cap-mask": 527,
	"./auth/campus-cap-mask.svg": 527,
	"./auth/campus-cap-mobile": 528,
	"./auth/campus-cap-mobile.png": 528,
	"./auth/campus-cap-registration": 529,
	"./auth/campus-cap-registration.jpg": 529,
	"./auth/campus-cap.jpg": 525,
	"./auth/cs-logo": 530,
	"./auth/cs-logo.svg": 530,
	"./auth/facebook": 531,
	"./auth/facebook.svg": 531,
	"./auth/facebook2": 532,
	"./auth/facebook2.svg": 532,
	"./auth/google": 533,
	"./auth/google.svg": 533,
	"./auth/leader": 496,
	"./auth/leader.jpg": 966,
	"./auth/leader.png": 496,
	"./auth/logo": 534,
	"./auth/logo.svg": 534,
	"./auth/pattern": 535,
	"./auth/pattern.png": 535,
	"./backgrounds/static": 536,
	"./backgrounds/static.jpg": 536,
	"./corporate/Illustration/Mockup/Data/Desktop": 537,
	"./corporate/Illustration/Mockup/Data/Desktop.png": 537,
	"./corporate/ad-banners": 538,
	"./corporate/ad-banners.png": 538,
	"./corporate/basic": 539,
	"./corporate/basic.svg": 539,
	"./corporate/benefits": 540,
	"./corporate/benefits.svg": 540,
	"./corporate/bg-corp": 541,
	"./corporate/bg-corp.jpg": 541,
	"./corporate/career": 542,
	"./corporate/career-mag": 543,
	"./corporate/career-mag-showcase": 544,
	"./corporate/career-mag-showcase.png": 544,
	"./corporate/career-mag.png": 543,
	"./corporate/career.png": 542,
	"./corporate/company_profile": 545,
	"./corporate/company_profile.png": 545,
	"./corporate/company_profile_1": 546,
	"./corporate/company_profile_1.svg": 546,
	"./corporate/company_profile_2": 547,
	"./corporate/company_profile_2.svg": 547,
	"./corporate/company_profile_3": 548,
	"./corporate/company_profile_3.svg": 548,
	"./corporate/company_profile_4": 549,
	"./corporate/company_profile_4.svg": 549,
	"./corporate/cover": 550,
	"./corporate/cover.png": 550,
	"./corporate/cover2": 551,
	"./corporate/cover2.png": 551,
	"./corporate/cover3": 552,
	"./corporate/cover3.png": 552,
	"./corporate/engaging": 553,
	"./corporate/engaging.png": 553,
	"./corporate/event-showcase": 554,
	"./corporate/event-showcase.png": 554,
	"./corporate/events": 555,
	"./corporate/events.png": 555,
	"./corporate/events2": 556,
	"./corporate/events2.png": 556,
	"./corporate/events3": 557,
	"./corporate/events3.png": 557,
	"./corporate/first-line": 558,
	"./corporate/first-line-mobile": 559,
	"./corporate/first-line-mobile.svg": 559,
	"./corporate/first-line.svg": 558,
	"./corporate/hero": 497,
	"./corporate/hero-mobile": 560,
	"./corporate/hero-mobile.png": 560,
	"./corporate/hero.jpg": 967,
	"./corporate/hero.png": 497,
	"./corporate/icon": 561,
	"./corporate/icon.svg": 561,
	"./corporate/job-add": 562,
	"./corporate/job-add.png": 562,
	"./corporate/job_ad": 563,
	"./corporate/job_ad.png": 563,
	"./corporate/logo": 564,
	"./corporate/logo-credit": 565,
	"./corporate/logo-credit.svg": 565,
	"./corporate/logo.svg": 564,
	"./corporate/logos-row": 566,
	"./corporate/logos-row.svg": 566,
	"./corporate/logos/abb": 567,
	"./corporate/logos/abb.svg": 567,
	"./corporate/logos/accenture": 568,
	"./corporate/logos/accenture.svg": 568,
	"./corporate/logos/adidas": 569,
	"./corporate/logos/adidas.svg": 569,
	"./corporate/logos/apple": 570,
	"./corporate/logos/apple.svg": 570,
	"./corporate/logos/axpo": 571,
	"./corporate/logos/axpo.svg": 571,
	"./corporate/logos/credit_suisse": 572,
	"./corporate/logos/credit_suisse.svg": 572,
	"./corporate/logos/ey": 573,
	"./corporate/logos/ey.svg": 573,
	"./corporate/logos/kpmg": 574,
	"./corporate/logos/kpmg.svg": 574,
	"./corporate/logos/loreal": 575,
	"./corporate/logos/loreal.svg": 575,
	"./corporate/logos/microsoft": 576,
	"./corporate/logos/microsoft.svg": 576,
	"./corporate/logos/porsche": 577,
	"./corporate/logos/porsche.svg": 577,
	"./corporate/logos/pwc": 578,
	"./corporate/logos/pwc.svg": 578,
	"./corporate/logos/sbb": 579,
	"./corporate/logos/sbb.svg": 579,
	"./corporate/logos/ubs": 580,
	"./corporate/logos/ubs.svg": 580,
	"./corporate/logos/vaudoise": 581,
	"./corporate/logos/vaudoise.svg": 581,
	"./corporate/logos/vz": 582,
	"./corporate/logos/vz.svg": 582,
	"./corporate/mask": 583,
	"./corporate/mask-mobile": 584,
	"./corporate/mask-mobile.svg": 584,
	"./corporate/mask.svg": 583,
	"./corporate/mini": 585,
	"./corporate/mini.svg": 585,
	"./corporate/newsletter-push": 586,
	"./corporate/newsletter-push.svg": 586,
	"./corporate/pac0": 587,
	"./corporate/pac0.svg": 587,
	"./corporate/pac1": 588,
	"./corporate/pac1.svg": 588,
	"./corporate/pac2": 589,
	"./corporate/pac2.svg": 589,
	"./corporate/pac3": 590,
	"./corporate/pac3.svg": 590,
	"./corporate/plus": 591,
	"./corporate/plus.svg": 591,
	"./corporate/premium": 592,
	"./corporate/premium.svg": 592,
	"./corporate/refresh-ccw": 593,
	"./corporate/refresh-ccw.svg": 593,
	"./corporate/second-line": 594,
	"./corporate/second-line-mobile": 595,
	"./corporate/second-line-mobile.svg": 595,
	"./corporate/second-line.svg": 594,
	"./corporate/section": 596,
	"./corporate/section.svg": 596,
	"./corporate/section2": 597,
	"./corporate/section2.svg": 597,
	"./corporate/social-media-push": 598,
	"./corporate/social-media-push.svg": 598,
	"./corporate/story": 599,
	"./corporate/story.png": 599,
	"./corporate/story_2": 600,
	"./corporate/story_2.png": 600,
	"./corporate/swiss": 601,
	"./corporate/swiss.png": 601,
	"./corporate/targeted_email": 602,
	"./corporate/targeted_email.png": 602,
	"./corporate/targeted_email_image": 603,
	"./corporate/targeted_email_image.png": 603,
	"./corporate/targeted_email_image2": 604,
	"./corporate/targeted_email_image2.png": 604,
	"./corporate/team": 605,
	"./corporate/team-fr": 606,
	"./corporate/team-fr.jpg": 606,
	"./corporate/team.jpg": 605,
	"./corporate/woman_in_banking": 607,
	"./corporate/woman_in_banking.png": 607,
	"./events/bg/interview": 608,
	"./events/bg/interview.jpg": 608,
	"./events/bg/location": 609,
	"./events/bg/location.jpg": 609,
	"./events/bg/registration": 610,
	"./events/bg/registration.jpg": 610,
	"./events/bg/schedule": 611,
	"./events/bg/schedule.jpg": 611,
	"./events/bg/section": 612,
	"./events/bg/section.jpg": 612,
	"./events/location/bicycle": 613,
	"./events/location/bicycle.svg": 613,
	"./events/location/bus": 614,
	"./events/location/bus.svg": 614,
	"./events/location/car": 615,
	"./events/location/car.svg": 615,
	"./events/location/walking": 616,
	"./events/location/walking.svg": 616,
	"./fallback/logo_image_item_file_default": 51,
	"./fallback/logo_image_item_file_default.png": 51,
	"./favicon/android-chrome-144x144": 256,
	"./favicon/android-chrome-144x144.png": 256,
	"./flags/de": 617,
	"./flags/de.svg": 617,
	"./flags/en": 618,
	"./flags/en.svg": 618,
	"./flags/fr": 619,
	"./flags/fr.svg": 619,
	"./flags/it": 620,
	"./flags/it.svg": 620,
	"./icons/search-no-results": 257,
	"./icons/search-no-results.svg": 257,
	"./info/cv-creator": 621,
	"./info/cv-creator.png": 621,
	"./info/events": 622,
	"./info/events.png": 622,
	"./info/jobs": 623,
	"./info/jobs.png": 623,
	"./info/magazine": 624,
	"./info/magazine.png": 624,
	"./landing/b-purple": 625,
	"./landing/b-purple.png": 625,
	"./landing/banner": 498,
	"./landing/banner.jpg": 968,
	"./landing/banner.png": 498,
	"./landing/banner1": 626,
	"./landing/banner1.png": 626,
	"./landing/hero": 627,
	"./landing/hero.jpg": 627,
	"./landing/hero_categories": 628,
	"./landing/hero_categories.jpg": 628,
	"./legal/legal": 629,
	"./legal/legal.jpg": 629,
	"./logos/accenture": 630,
	"./logos/accenture.svg": 630,
	"./logos/apple": 631,
	"./logos/apple.svg": 631,
	"./logos/bosch": 632,
	"./logos/bosch.svg": 632,
	"./logos/deloitte": 633,
	"./logos/deloitte.svg": 633,
	"./logos/kpmg": 634,
	"./logos/kpmg.svg": 634,
	"./logos/legi": 635,
	"./logos/legi.svg": 635,
	"./logos/lidl": 636,
	"./logos/lidl.svg": 636,
	"./logos/loreal": 637,
	"./logos/loreal.svg": 637,
	"./logos/swiss": 638,
	"./logos/swiss.svg": 638,
	"./logos/ubs": 639,
	"./logos/ubs.svg": 639,
	"./logos/сorporate": 640,
	"./logos/сorporate.svg": 640,
	"./mask/angle": 641,
	"./mask/angle.svg": 641,
	"./mask/polygon": 642,
	"./mask/polygon.svg": 642,
	"./mask/triangle": 643,
	"./mask/triangle.svg": 643,
	"./pages/career-starter/01": 644,
	"./pages/career-starter/01.png": 644,
	"./pages/career-starter/02": 645,
	"./pages/career-starter/02.png": 645,
	"./pages/career-starter/03": 646,
	"./pages/career-starter/03.png": 646,
	"./pages/career-starter/04": 647,
	"./pages/career-starter/04.png": 647,
	"./pages/career-starter/05": 648,
	"./pages/career-starter/05.png": 648,
	"./pages/career-starter/06": 649,
	"./pages/career-starter/06.png": 649,
	"./pages/career-starter/07": 650,
	"./pages/career-starter/07.png": 650,
	"./pages/career-starter/bg": 651,
	"./pages/career-starter/bg.jpg": 651,
	"./pages/career-starter/collection/2018_de": 652,
	"./pages/career-starter/collection/2018_de.jpg": 652,
	"./pages/career-starter/collection/2018_fr": 653,
	"./pages/career-starter/collection/2018_fr.jpg": 653,
	"./pages/career-starter/collection/2019_de": 654,
	"./pages/career-starter/collection/2019_de.jpg": 654,
	"./pages/career-starter/collection/2019_fr": 655,
	"./pages/career-starter/collection/2019_fr.jpg": 655,
	"./pages/career-starter/collection/2020_de": 656,
	"./pages/career-starter/collection/2020_de.jpg": 656,
	"./pages/career-starter/collection/2020_fr": 657,
	"./pages/career-starter/collection/2020_fr.jpg": 657,
	"./pages/career-starter/collection/2021_de": 658,
	"./pages/career-starter/collection/2021_de.jpg": 658,
	"./pages/career-starter/collection/2021_fr": 659,
	"./pages/career-starter/collection/2021_fr.jpg": 659,
	"./pages/career-starter/collection/2022_de": 660,
	"./pages/career-starter/collection/2022_de.jpg": 660,
	"./pages/career-starter/collection/2022_fr": 661,
	"./pages/career-starter/collection/2022_fr.jpg": 661,
	"./pages/career-starter/collection/2023_de": 662,
	"./pages/career-starter/collection/2023_de.jpg": 662,
	"./pages/career-starter/collection/2023_fr": 663,
	"./pages/career-starter/collection/2023_fr.jpg": 663,
	"./pages/career-starter/collection/2024_de": 664,
	"./pages/career-starter/collection/2024_de.jpg": 664,
	"./pages/career-starter/collection/2024_fr": 665,
	"./pages/career-starter/collection/2024_fr.jpg": 665,
	"./pages/career-starter/collection/2025_de": 666,
	"./pages/career-starter/collection/2025_de.jpg": 666,
	"./pages/career-starter/collection/2025_fr": 667,
	"./pages/career-starter/collection/2025_fr.jpg": 667,
	"./pages/career-starter/hero-de": 668,
	"./pages/career-starter/hero-de.png": 668,
	"./pages/career-starter/hero-fr": 669,
	"./pages/career-starter/hero-fr.png": 669,
	"./pages/career-starter/regions/aargau": 670,
	"./pages/career-starter/regions/aargau.png": 670,
	"./pages/career-starter/regions/bern": 671,
	"./pages/career-starter/regions/bern-de": 672,
	"./pages/career-starter/regions/bern-de.png": 672,
	"./pages/career-starter/regions/bern-fr": 673,
	"./pages/career-starter/regions/bern-fr.png": 673,
	"./pages/career-starter/regions/bern.png": 671,
	"./pages/career-starter/regions/fribourg": 674,
	"./pages/career-starter/regions/fribourg.jpg": 674,
	"./pages/career-starter/regions/geneve": 675,
	"./pages/career-starter/regions/geneve.png": 675,
	"./pages/career-starter/regions/glarus": 676,
	"./pages/career-starter/regions/glarus.jpg": 676,
	"./pages/career-starter/regions/graubuenden": 677,
	"./pages/career-starter/regions/graubuenden.png": 677,
	"./pages/career-starter/regions/luzern": 678,
	"./pages/career-starter/regions/luzern.png": 678,
	"./pages/career-starter/regions/neuenburg": 679,
	"./pages/career-starter/regions/neuenburg.png": 679,
	"./pages/career-starter/regions/obwalden": 680,
	"./pages/career-starter/regions/obwalden.jpg": 680,
	"./pages/career-starter/regions/ostschweiz": 681,
	"./pages/career-starter/regions/ostschweiz.jpg": 681,
	"./pages/career-starter/regions/solothurn": 682,
	"./pages/career-starter/regions/solothurn.png": 682,
	"./pages/career-starter/regions/uri": 683,
	"./pages/career-starter/regions/uri.png": 683,
	"./pages/career-starter/regions/vaud": 684,
	"./pages/career-starter/regions/vaud.png": 684,
	"./pages/career-starter/regions/wappen-wallis": 685,
	"./pages/career-starter/regions/wappen-wallis.jpg": 685,
	"./pages/companies/accenture": 686,
	"./pages/companies/accenture.png": 686,
	"./pages/companies/adnovum": 687,
	"./pages/companies/adnovum.png": 687,
	"./pages/companies/air_up": 688,
	"./pages/companies/air_up.png": 688,
	"./pages/companies/aldi": 689,
	"./pages/companies/aldi.png": 689,
	"./pages/companies/allianz": 690,
	"./pages/companies/allianz.jpg": 690,
	"./pages/companies/audemars": 691,
	"./pages/companies/audemars.webp": 691,
	"./pages/companies/avaloq": 692,
	"./pages/companies/avaloq.png": 692,
	"./pages/companies/axpo": 693,
	"./pages/companies/axpo-new": 694,
	"./pages/companies/axpo-new.png": 694,
	"./pages/companies/axpo.png": 693,
	"./pages/companies/bank-cler": 695,
	"./pages/companies/bank-cler.png": 695,
	"./pages/companies/bcv": 696,
	"./pages/companies/bcv.png": 696,
	"./pages/companies/bdo": 697,
	"./pages/companies/bdo.png": 697,
	"./pages/companies/be": 698,
	"./pages/companies/be.jpg": 698,
	"./pages/companies/bkw": 699,
	"./pages/companies/bkw.png": 699,
	"./pages/companies/bkw_green": 700,
	"./pages/companies/bkw_green.png": 700,
	"./pages/companies/bosch": 701,
	"./pages/companies/bosch.png": 701,
	"./pages/companies/brugg": 702,
	"./pages/companies/brugg.png": 702,
	"./pages/companies/brugg_group": 703,
	"./pages/companies/brugg_group.png": 703,
	"./pages/companies/buhler": 704,
	"./pages/companies/buhler.png": 704,
	"./pages/companies/bundesverwaltung": 705,
	"./pages/companies/bundesverwaltung.png": 705,
	"./pages/companies/bystronic": 706,
	"./pages/companies/bystronic.png": 706,
	"./pages/companies/camptocamp": 707,
	"./pages/companies/camptocamp.png": 707,
	"./pages/companies/careerplus_de": 708,
	"./pages/companies/careerplus_de.png": 708,
	"./pages/companies/careerplus_fr": 709,
	"./pages/companies/careerplus_fr.png": 709,
	"./pages/companies/carrerplus": 710,
	"./pages/companies/carrerplus.png": 710,
	"./pages/companies/centris": 711,
	"./pages/companies/centris.png": 711,
	"./pages/companies/chuv": 712,
	"./pages/companies/chuv.jpg": 712,
	"./pages/companies/cinfo": 713,
	"./pages/companies/cinfo-new": 714,
	"./pages/companies/cinfo-new.png": 714,
	"./pages/companies/cinfo.png": 713,
	"./pages/companies/ckw": 715,
	"./pages/companies/ckw-axpo-group": 716,
	"./pages/companies/ckw-axpo-group.png": 716,
	"./pages/companies/ckw.png": 715,
	"./pages/companies/collini": 717,
	"./pages/companies/collini.png": 717,
	"./pages/companies/comet": 718,
	"./pages/companies/comet.png": 718,
	"./pages/companies/comet_new": 719,
	"./pages/companies/comet_new.png": 719,
	"./pages/companies/covance": 720,
	"./pages/companies/covance.jpg": 720,
	"./pages/companies/covance_new": 721,
	"./pages/companies/covance_new.jpg": 721,
	"./pages/companies/csl": 722,
	"./pages/companies/csl-new": 723,
	"./pages/companies/csl-new.png": 723,
	"./pages/companies/csl.png": 722,
	"./pages/companies/denner": 724,
	"./pages/companies/denner.png": 724,
	"./pages/companies/duotec": 725,
	"./pages/companies/duotec.png": 725,
	"./pages/companies/e+h": 726,
	"./pages/companies/e+h-vertical": 727,
	"./pages/companies/e+h-vertical.png": 727,
	"./pages/companies/e+h.png": 726,
	"./pages/companies/eandh": 728,
	"./pages/companies/eandh.png": 728,
	"./pages/companies/ehl-hospitality-business-school": 729,
	"./pages/companies/ehl-hospitality-business-school.webp": 729,
	"./pages/companies/ems": 730,
	"./pages/companies/ems.png": 730,
	"./pages/companies/epfl": 731,
	"./pages/companies/epfl.png": 731,
	"./pages/companies/etat-de-genève": 732,
	"./pages/companies/etat-de-genève.webp": 732,
	"./pages/companies/etat-de-vaud": 733,
	"./pages/companies/etat-de-vaud.png": 733,
	"./pages/companies/ewp": 734,
	"./pages/companies/ewp.jpg": 734,
	"./pages/companies/ey": 735,
	"./pages/companies/ey.png": 735,
	"./pages/companies/fachhochschule-nordwestschweiz": 736,
	"./pages/companies/fachhochschule-nordwestschweiz.jpg": 736,
	"./pages/companies/fachhochschulesu_dschweiz": 737,
	"./pages/companies/fachhochschulesu_dschweiz.png": 737,
	"./pages/companies/fenaco": 738,
	"./pages/companies/fenaco-new": 739,
	"./pages/companies/fenaco-new.png": 739,
	"./pages/companies/fenaco.png": 738,
	"./pages/companies/generali": 740,
	"./pages/companies/generali.png": 740,
	"./pages/companies/georg_fischer": 741,
	"./pages/companies/georg_fischer.png": 741,
	"./pages/companies/graub": 742,
	"./pages/companies/graub.png": 742,
	"./pages/companies/groupe-mutuel": 491,
	"./pages/companies/groupe-mutuel-new": 743,
	"./pages/companies/groupe-mutuel-new.png": 743,
	"./pages/companies/groupe-mutuel.jpg": 969,
	"./pages/companies/groupe-mutuel.png": 491,
	"./pages/companies/groupe-mutuel.webp": 970,
	"./pages/companies/groupemutuel-vertical": 744,
	"./pages/companies/groupemutuel-vertical.png": 744,
	"./pages/companies/hamilton": 745,
	"./pages/companies/hamilton.png": 745,
	"./pages/companies/hays": 746,
	"./pages/companies/hays-new": 747,
	"./pages/companies/hays-new.png": 747,
	"./pages/companies/hays.png": 746,
	"./pages/companies/heig-vd-text": 748,
	"./pages/companies/heig-vd-text.png": 748,
	"./pages/companies/heig_vd": 749,
	"./pages/companies/heig_vd.png": 749,
	"./pages/companies/helvetia": 750,
	"./pages/companies/helvetia.jpg": 750,
	"./pages/companies/hes-so": 751,
	"./pages/companies/hes-so.webp": 751,
	"./pages/companies/hewlettpackard": 752,
	"./pages/companies/hewlettpackard.png": 752,
	"./pages/companies/hospice-general": 753,
	"./pages/companies/hospice-general.png": 753,
	"./pages/companies/hotelleriesuisse": 754,
	"./pages/companies/hotelleriesuisse.png": 754,
	"./pages/companies/hslu": 755,
	"./pages/companies/hslu.png": 755,
	"./pages/companies/huawei": 756,
	"./pages/companies/huawei.png": 756,
	"./pages/companies/hug": 757,
	"./pages/companies/hug-logo": 758,
	"./pages/companies/hug-logo.png": 758,
	"./pages/companies/hug.png": 757,
	"./pages/companies/inventx": 759,
	"./pages/companies/inventx.png": 759,
	"./pages/companies/j-w": 760,
	"./pages/companies/j-w-fr": 761,
	"./pages/companies/j-w-fr.png": 761,
	"./pages/companies/j-w.jpg": 760,
	"./pages/companies/jura": 762,
	"./pages/companies/jura.jpg": 762,
	"./pages/companies/kmpg_ag": 763,
	"./pages/companies/kmpg_ag.png": 763,
	"./pages/companies/laposte": 764,
	"./pages/companies/laposte.png": 764,
	"./pages/companies/lgt": 765,
	"./pages/companies/lgt-pb": 766,
	"./pages/companies/lgt-pb.png": 766,
	"./pages/companies/lgt.png": 765,
	"./pages/companies/lidl": 767,
	"./pages/companies/lidl.png": 767,
	"./pages/companies/liechtensteinische_landsbank": 768,
	"./pages/companies/liechtensteinische_landsbank.jpg": 768,
	"./pages/companies/lonza": 499,
	"./pages/companies/lonza.jpg": 971,
	"./pages/companies/lonza.png": 499,
	"./pages/companies/loterie-romande": 769,
	"./pages/companies/loterie-romande-horizontal": 770,
	"./pages/companies/loterie-romande-horizontal.png": 770,
	"./pages/companies/loterie-romande.png": 769,
	"./pages/companies/manor": 771,
	"./pages/companies/manor.png": 771,
	"./pages/companies/medair": 772,
	"./pages/companies/medair.png": 772,
	"./pages/companies/meggitt": 773,
	"./pages/companies/meggitt.jpg": 773,
	"./pages/companies/melexis": 774,
	"./pages/companies/melexis.png": 774,
	"./pages/companies/migros-gruppe": 775,
	"./pages/companies/migros-gruppe.png": 775,
	"./pages/companies/mikron": 776,
	"./pages/companies/mikron-new": 777,
	"./pages/companies/mikron-new.png": 777,
	"./pages/companies/mikron.png": 776,
	"./pages/companies/mikron_automat": 778,
	"./pages/companies/mikron_automat.webp": 778,
	"./pages/companies/ms": 779,
	"./pages/companies/ms.png": 779,
	"./pages/companies/nestle": 780,
	"./pages/companies/nestle.png": 780,
	"./pages/companies/noser-engineering": 781,
	"./pages/companies/noser-engineering.png": 781,
	"./pages/companies/ost": 782,
	"./pages/companies/ost.png": 782,
	"./pages/companies/pmi": 783,
	"./pages/companies/pmi.png": 783,
	"./pages/companies/pmint": 784,
	"./pages/companies/pmint.png": 784,
	"./pages/companies/post": 785,
	"./pages/companies/post.png": 785,
	"./pages/companies/postfinance": 786,
	"./pages/companies/postfinance.png": 786,
	"./pages/companies/rheinmetall": 787,
	"./pages/companies/rheinmetall.png": 787,
	"./pages/companies/rheinmetall_defence": 788,
	"./pages/companies/rheinmetall_defence.png": 788,
	"./pages/companies/rolex": 789,
	"./pages/companies/rolex.png": 789,
	"./pages/companies/romande-energie": 790,
	"./pages/companies/romande-energie.png": 790,
	"./pages/companies/ruag": 791,
	"./pages/companies/ruag.png": 791,
	"./pages/companies/safran": 792,
	"./pages/companies/safran.png": 792,
	"./pages/companies/schindler": 500,
	"./pages/companies/schindler.jpg": 972,
	"./pages/companies/schindler.png": 500,
	"./pages/companies/schott": 793,
	"./pages/companies/schott.png": 793,
	"./pages/companies/sicpa": 794,
	"./pages/companies/sicpa.png": 794,
	"./pages/companies/siegfried": 795,
	"./pages/companies/siegfried.jpg": 795,
	"./pages/companies/sko": 796,
	"./pages/companies/sko.png": 796,
	"./pages/companies/skyguide": 797,
	"./pages/companies/skyguide.png": 797,
	"./pages/companies/smn": 798,
	"./pages/companies/smn.jpg": 798,
	"./pages/companies/solvias": 799,
	"./pages/companies/solvias.png": 799,
	"./pages/companies/sonceboz": 800,
	"./pages/companies/sonceboz.png": 800,
	"./pages/companies/stadt-zurich-horizontal": 801,
	"./pages/companies/stadt-zurich-horizontal.png": 801,
	"./pages/companies/stadt-zürich": 802,
	"./pages/companies/stadt-zürich.png": 802,
	"./pages/companies/supsi": 803,
	"./pages/companies/supsi.png": 803,
	"./pages/companies/suva": 804,
	"./pages/companies/suva.png": 804,
	"./pages/companies/swissgrid": 805,
	"./pages/companies/swissgrid.jpg": 805,
	"./pages/companies/switch": 806,
	"./pages/companies/switch.png": 806,
	"./pages/companies/syngenta": 807,
	"./pages/companies/syngenta.png": 807,
	"./pages/companies/syntegon": 808,
	"./pages/companies/syntegon.png": 808,
	"./pages/companies/t-systems": 809,
	"./pages/companies/t-systems.png": 809,
	"./pages/companies/tcs": 810,
	"./pages/companies/tcs.png": 810,
	"./pages/companies/thyssenkrupp": 811,
	"./pages/companies/thyssenkrupp.png": 811,
	"./pages/companies/ubp": 812,
	"./pages/companies/ubp.png": 812,
	"./pages/companies/umb": 813,
	"./pages/companies/umb.png": 813,
	"./pages/companies/uni-basel": 814,
	"./pages/companies/uni-basel.webp": 814,
	"./pages/companies/uni_basel": 815,
	"./pages/companies/uni_basel.png": 815,
	"./pages/companies/unilever": 816,
	"./pages/companies/unilever.jpg": 816,
	"./pages/companies/uniluzern": 817,
	"./pages/companies/uniluzern.png": 817,
	"./pages/companies/unistgallen": 818,
	"./pages/companies/unistgallen.png": 818,
	"./pages/companies/vaudoise": 819,
	"./pages/companies/vaudoise.png": 819,
	"./pages/companies/vermo_gens_zentrum": 820,
	"./pages/companies/vermo_gens_zentrum.png": 820,
	"./pages/companies/vermogenszentrum": 501,
	"./pages/companies/vermogenszentrum.jpg": 973,
	"./pages/companies/vermogenszentrum.png": 501,
	"./pages/companies/wwf": 821,
	"./pages/companies/wwf.png": 821,
	"./pages/companies/yuh": 822,
	"./pages/companies/yuh.png": 822,
	"./pages/companies/zhaw": 823,
	"./pages/companies/zhaw.png": 823,
	"./pages/companies/zhaw_life_scienses": 824,
	"./pages/companies/zhaw_life_scienses.png": 824,
	"./pages/companies/zhaw_lsfm": 825,
	"./pages/companies/zhaw_lsfm.png": 825,
	"./pages/companies/zhaw_sml": 826,
	"./pages/companies/zhaw_sml.png": 826,
	"./pages/companies/zuehlke": 827,
	"./pages/companies/zuehlke.png": 827,
	"./pages/companies/zurcher_kantonalbank": 828,
	"./pages/companies/zurcher_kantonalbank.jpg": 828,
	"./pages/cv_example": 829,
	"./pages/cv_example.jpg": 829,
	"./pages/cv_icon": 830,
	"./pages/cv_icon.svg": 830,
	"./pages/profile/aldi ger 1": 831,
	"./pages/profile/aldi ger 1.jpg": 831,
	"./pages/profile/aldi ger 2": 832,
	"./pages/profile/aldi ger 2.jpg": 832,
	"./pages/profile/aldi ger 3": 833,
	"./pages/profile/aldi ger 3.jpg": 833,
	"./pages/profile/aldi ger 4": 834,
	"./pages/profile/aldi ger 4.jpg": 834,
	"./pages/profile/aldi ger 5": 835,
	"./pages/profile/aldi ger 5.jpg": 835,
	"./pages/profile/aldi ger 6": 836,
	"./pages/profile/aldi ger 6.jpg": 836,
	"./pages/profile/aldi ger 7": 837,
	"./pages/profile/aldi ger 7.jpg": 837,
	"./pages/profile/aldi ger 8": 838,
	"./pages/profile/aldi ger 8.jpg": 838,
	"./pages/profile/axpo ger 1": 839,
	"./pages/profile/axpo ger 1.jpg": 839,
	"./pages/profile/axpo ger 10": 840,
	"./pages/profile/axpo ger 10.jpg": 840,
	"./pages/profile/axpo ger 11": 841,
	"./pages/profile/axpo ger 11.jpg": 841,
	"./pages/profile/axpo ger 12": 842,
	"./pages/profile/axpo ger 12.jpg": 842,
	"./pages/profile/axpo ger 13": 843,
	"./pages/profile/axpo ger 13.jpg": 843,
	"./pages/profile/axpo ger 14": 844,
	"./pages/profile/axpo ger 14.jpg": 844,
	"./pages/profile/axpo ger 15": 845,
	"./pages/profile/axpo ger 15.jpg": 845,
	"./pages/profile/axpo ger 2": 846,
	"./pages/profile/axpo ger 2.jpg": 846,
	"./pages/profile/axpo ger 3": 847,
	"./pages/profile/axpo ger 3.jpg": 847,
	"./pages/profile/axpo ger 4": 848,
	"./pages/profile/axpo ger 4.jpg": 848,
	"./pages/profile/axpo ger 5": 849,
	"./pages/profile/axpo ger 5.jpg": 849,
	"./pages/profile/axpo ger 6": 850,
	"./pages/profile/axpo ger 6.jpg": 850,
	"./pages/profile/axpo ger 7": 851,
	"./pages/profile/axpo ger 7.jpg": 851,
	"./pages/profile/axpo ger 8": 852,
	"./pages/profile/axpo ger 8.jpg": 852,
	"./pages/profile/axpo ger 9": 853,
	"./pages/profile/axpo ger 9.jpg": 853,
	"./pages/profile/bund ger 1": 854,
	"./pages/profile/bund ger 1.jpg": 854,
	"./pages/profile/bund ger 10": 855,
	"./pages/profile/bund ger 10.jpg": 855,
	"./pages/profile/bund ger 11": 856,
	"./pages/profile/bund ger 11.jpg": 856,
	"./pages/profile/bund ger 12": 857,
	"./pages/profile/bund ger 12.jpg": 857,
	"./pages/profile/bund ger 13": 858,
	"./pages/profile/bund ger 13.jpg": 858,
	"./pages/profile/bund ger 14": 859,
	"./pages/profile/bund ger 14.jpg": 859,
	"./pages/profile/bund ger 15": 860,
	"./pages/profile/bund ger 15.jpg": 860,
	"./pages/profile/bund ger 2": 861,
	"./pages/profile/bund ger 2.jpg": 861,
	"./pages/profile/bund ger 3": 862,
	"./pages/profile/bund ger 3.jpg": 862,
	"./pages/profile/bund ger 4": 863,
	"./pages/profile/bund ger 4.jpg": 863,
	"./pages/profile/bund ger 5": 864,
	"./pages/profile/bund ger 5.jpg": 864,
	"./pages/profile/bund ger 6": 865,
	"./pages/profile/bund ger 6.jpg": 865,
	"./pages/profile/bund ger 7": 866,
	"./pages/profile/bund ger 7.jpg": 866,
	"./pages/profile/bund ger 8": 867,
	"./pages/profile/bund ger 8.jpg": 867,
	"./pages/profile/bund ger 9": 868,
	"./pages/profile/bund ger 9.jpg": 868,
	"./pages/profile/ckw ger 1": 869,
	"./pages/profile/ckw ger 1.jpg": 869,
	"./pages/profile/ckw ger 2": 870,
	"./pages/profile/ckw ger 2.jpg": 870,
	"./pages/profile/ckw ger 3": 871,
	"./pages/profile/ckw ger 3.jpg": 871,
	"./pages/profile/ckw ger 4": 872,
	"./pages/profile/ckw ger 4.jpg": 872,
	"./pages/profile/ckw ger 5": 873,
	"./pages/profile/ckw ger 5.jpg": 873,
	"./pages/profile/ckw ger 6": 874,
	"./pages/profile/ckw ger 6.jpg": 874,
	"./pages/profile/csl ger 1": 875,
	"./pages/profile/csl ger 1.jpg": 875,
	"./pages/profile/csl ger 2": 876,
	"./pages/profile/csl ger 2.jpg": 876,
	"./pages/profile/csl ger 3": 877,
	"./pages/profile/csl ger 3.jpg": 877,
	"./pages/profile/csl ger 4": 878,
	"./pages/profile/csl ger 4.jpg": 878,
	"./pages/profile/csl ger 5": 879,
	"./pages/profile/csl ger 5.jpg": 879,
	"./pages/profile/csl ger 6": 880,
	"./pages/profile/csl ger 6.jpg": 880,
	"./pages/profile/fenaco ger 1": 881,
	"./pages/profile/fenaco ger 1.jpg": 881,
	"./pages/profile/fenaco ger 2": 882,
	"./pages/profile/fenaco ger 2.jpg": 882,
	"./pages/profile/fenaco ger 3": 883,
	"./pages/profile/fenaco ger 3.jpg": 883,
	"./pages/profile/fenaco ger 4": 884,
	"./pages/profile/fenaco ger 4.jpg": 884,
	"./pages/profile/fenaco ger 5": 885,
	"./pages/profile/fenaco ger 5.jpg": 885,
	"./pages/profile/fenaco ger 6": 886,
	"./pages/profile/fenaco ger 6.jpg": 886,
	"./pages/profile/fenaco ger 7": 887,
	"./pages/profile/fenaco ger 7.jpg": 887,
	"./pages/profile/fenaco ger 8": 888,
	"./pages/profile/fenaco ger 8.jpg": 888,
	"./pages/profile/fenaco ger 9": 889,
	"./pages/profile/fenaco ger 9.jpg": 889,
	"./pages/profile/hslu ger 1": 890,
	"./pages/profile/hslu ger 1.jpg": 890,
	"./pages/profile/hslu ger 2": 891,
	"./pages/profile/hslu ger 2.jpg": 891,
	"./pages/profile/hslu ger 3": 892,
	"./pages/profile/hslu ger 3.jpg": 892,
	"./pages/profile/hslu ger 4": 893,
	"./pages/profile/hslu ger 4.jpg": 893,
	"./pages/profile/hslu ger 5": 894,
	"./pages/profile/hslu ger 5.jpg": 894,
	"./pages/profile/hslu ger 6": 895,
	"./pages/profile/hslu ger 6.jpg": 895,
	"./pages/profile/hslu ger 7": 896,
	"./pages/profile/hslu ger 7.jpg": 896,
	"./pages/profile/hslu ger 8": 897,
	"./pages/profile/hslu ger 8.jpg": 897,
	"./pages/profile/hug fr 1": 898,
	"./pages/profile/hug fr 1.jpg": 898,
	"./pages/profile/hug fr 2": 899,
	"./pages/profile/hug fr 2.jpg": 899,
	"./pages/profile/hug fr 3": 900,
	"./pages/profile/hug fr 3.jpg": 900,
	"./pages/profile/kpmg fr 1": 901,
	"./pages/profile/kpmg fr 1.jpg": 901,
	"./pages/profile/kpmg fr 2": 902,
	"./pages/profile/kpmg fr 2.jpg": 902,
	"./pages/profile/kpmg fr 3": 903,
	"./pages/profile/kpmg fr 3.jpg": 903,
	"./pages/profile/kpmg ger 1": 904,
	"./pages/profile/kpmg ger 1.jpg": 904,
	"./pages/profile/kpmg ger 10": 905,
	"./pages/profile/kpmg ger 10.jpg": 905,
	"./pages/profile/kpmg ger 11": 906,
	"./pages/profile/kpmg ger 11.jpg": 906,
	"./pages/profile/kpmg ger 12": 907,
	"./pages/profile/kpmg ger 12.jpg": 907,
	"./pages/profile/kpmg ger 13": 908,
	"./pages/profile/kpmg ger 13.jpg": 908,
	"./pages/profile/kpmg ger 14": 909,
	"./pages/profile/kpmg ger 14.jpg": 909,
	"./pages/profile/kpmg ger 2": 910,
	"./pages/profile/kpmg ger 2.jpg": 910,
	"./pages/profile/kpmg ger 3": 911,
	"./pages/profile/kpmg ger 3.jpg": 911,
	"./pages/profile/kpmg ger 4": 912,
	"./pages/profile/kpmg ger 4.jpg": 912,
	"./pages/profile/kpmg ger 5": 913,
	"./pages/profile/kpmg ger 5.jpg": 913,
	"./pages/profile/kpmg ger 6": 914,
	"./pages/profile/kpmg ger 6.jpg": 914,
	"./pages/profile/kpmg ger 7": 915,
	"./pages/profile/kpmg ger 7.jpg": 915,
	"./pages/profile/kpmg ger 8": 916,
	"./pages/profile/kpmg ger 8.jpg": 916,
	"./pages/profile/kpmg ger 9": 917,
	"./pages/profile/kpmg ger 9.jpg": 917,
	"./pages/profile/lgt ger 1": 918,
	"./pages/profile/lgt ger 1.jpg": 918,
	"./pages/profile/lgt ger 10": 919,
	"./pages/profile/lgt ger 10.jpg": 919,
	"./pages/profile/lgt ger 2": 920,
	"./pages/profile/lgt ger 2.jpg": 920,
	"./pages/profile/lgt ger 3": 921,
	"./pages/profile/lgt ger 3.jpg": 921,
	"./pages/profile/lgt ger 8": 922,
	"./pages/profile/lgt ger 8.jpg": 922,
	"./pages/profile/lgt ger 9": 923,
	"./pages/profile/lgt ger 9.jpg": 923,
	"./pages/profile/lidl ger 1": 924,
	"./pages/profile/lidl ger 1.jpg": 924,
	"./pages/profile/lidl ger 2": 925,
	"./pages/profile/lidl ger 2.jpg": 925,
	"./pages/profile/lidl ger 3": 926,
	"./pages/profile/lidl ger 3.jpg": 926,
	"./pages/profile/lidl ger 4": 927,
	"./pages/profile/lidl ger 4.jpg": 927,
	"./pages/profile/lidl ger 5": 928,
	"./pages/profile/lidl ger 5.jpg": 928,
	"./pages/profile/lidl ger 6": 929,
	"./pages/profile/lidl ger 6.jpg": 929,
	"./pages/profile/lidl ger 7": 930,
	"./pages/profile/lidl ger 7.jpg": 930,
	"./pages/profile/migros ger 1": 931,
	"./pages/profile/migros ger 1.jpg": 931,
	"./pages/profile/migros ger 2": 932,
	"./pages/profile/migros ger 2.jpg": 932,
	"./pages/profile/migros ger 3": 933,
	"./pages/profile/migros ger 3.jpg": 933,
	"./pages/profile/uni basel ger 1": 934,
	"./pages/profile/uni basel ger 1.jpg": 934,
	"./pages/profile/uni basel ger 2": 935,
	"./pages/profile/uni basel ger 2.jpg": 935,
	"./pages/profile/vaudoise ger 1": 936,
	"./pages/profile/vaudoise ger 1.jpg": 936,
	"./pages/profile/vaudoise ger 2": 937,
	"./pages/profile/vaudoise ger 2.jpg": 937,
	"./pages/profile/vaudoise ger 3": 938,
	"./pages/profile/vaudoise ger 3.jpg": 938,
	"./pages/profile/vaudoise ger 4": 939,
	"./pages/profile/vaudoise ger 4.jpg": 939,
	"./pages/profile/vaudoise ger 5": 940,
	"./pages/profile/vaudoise ger 5.jpg": 940,
	"./pages/profile/vaudoise ger 6": 941,
	"./pages/profile/vaudoise ger 6.jpg": 941,
	"./pages/profile/zhaw ger 1": 942,
	"./pages/profile/zhaw ger 1.jpg": 942,
	"./pages/profile/zhaw ger 2": 943,
	"./pages/profile/zhaw ger 2.jpg": 943,
	"./pages/profile/zhaw ger 3": 944,
	"./pages/profile/zhaw ger 3.jpg": 944,
	"./pages/profile/zhaw ger 4": 945,
	"./pages/profile/zhaw ger 4.jpg": 945,
	"./pages/profile/zhaw ger 5": 946,
	"./pages/profile/zhaw ger 5.jpg": 946,
	"./pages/profile/zhaw ger 6": 947,
	"./pages/profile/zhaw ger 6.jpg": 947,
	"./pages/talent_career/hero-de": 948,
	"./pages/talent_career/hero-de.jpg": 948,
	"./pages/talent_career/hero-fr": 949,
	"./pages/talent_career/hero-fr.jpg": 949,
	"./prices/ad-banners": 950,
	"./prices/ad-banners.png": 950,
	"./prices/career-mag": 951,
	"./prices/career-mag.png": 951,
	"./prices/company-profile": 952,
	"./prices/company-profile.png": 952,
	"./prices/events": 953,
	"./prices/events.png": 953,
	"./prices/job-ad": 954,
	"./prices/job-ad.png": 954,
	"./prices/master-card": 955,
	"./prices/master-card.svg": 955,
	"./prices/targeted-emails": 956,
	"./prices/targeted-emails.png": 956,
	"./prices/visa": 957,
	"./prices/visa.svg": 957,
	"./support/contacts": 958,
	"./support/contacts-fr": 959,
	"./support/contacts-fr.jpg": 959,
	"./support/contacts.jpg": 958,
	"./trainee-program/card_career": 960,
	"./trainee-program/card_career.jpg": 960,
	"./trainee-program/card_cv": 961,
	"./trainee-program/card_cv.png": 961,
	"./trainee-program/card_magazine": 962,
	"./trainee-program/card_magazine.png": 962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 965;